import MasterTab from 'src/components/Layouts/MasterTab.vue';
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';
import Nursery from 'src/views/Pages/Dashboard/Nursery/Nursery/Nurseries.vue';
import ReasonRejection from 'src/views/Pages/Dashboard/Nursery/ReasonRejection/ReasonRejection.vue';
import NurseryCatch from 'src/views/Pages/Dashboard/Nursery/NurseryCatch/Catch.vue';

const NurseriesRoutes = {
  path: 'nursery',
  name: 'sowing.nursery',
  component: MasterTab,
  props: { reference: 'nurseryTabs' },
  children: [
    {
      path: 'nursery',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'sowing.nursery',
          component: Nursery,
          meta: {
            prefix_permission: 'nursery_nursery',
          },
        },
      ],
    },
    {
      path: 'reasonrejection',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'sowing.reason_rejection',
          component: ReasonRejection,
          meta: {
            prefix_permission: 'nursery_reasonrejection',
          },
        },
      ],
    },
    {
      path: 'nurserycatch',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'sowing.nursery_catch',
          component: NurseryCatch,
          meta: {
            prefix_permission: 'nursery_nurserycatch',
          },
        },
      ],
    },
  ]
};

export default NurseriesRoutes;